import React, { useEffect, useMemo, useRef } from 'react';
import NewsletterManagment from './screens/Newsletter/Management/NewsletterManagment';
import CampaignEditorBee from './screens/HtmlCampaign/CampaignEditorBee';
import BeeEditor from './screens/Editors/BeeEditor';
import ArchiveManagement from './screens/Newsletter/Management/ArchiveManagement';
import AutomationManagment from './screens/Automations/Management/AutomationsManagment';
import LandingPagesesManagment from './screens/LandingPages/Management/LandingPagesManagment';
import MmsManagment from './screens/Mms/Management/MmsManagment';
import PopUpManagement from './screens/LandingPages/PopUpManagement/PopUpManagement';
import SmsManagment from './screens/Sms/Management/SmsManagment';
import {
  getCookie,
  setCookie,
  cookieListener,
} from './helpers/Functions/cookies';
import { buildPulseemUser } from './helpers/Functions/buildPulseemUser';
import { create } from 'jss';
import rtl from 'jss-rtl';
import jwt_decode from "jwt-decode";
import { StylesProvider, jssPreset, MuiThemeProvider } from '@material-ui/core/styles';
import i18n from './i18n'
import { BrowserRouter, useParams, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setWindowSize,
  setCoreData,
  setLanguage,
  setRowsPerPage,
  setIsClal,
  setDarkModeTransient
} from './redux/reducers/coreSlice'; //smsOldVersion
import { GetAfterLoginInitialData, getCommonFeatures, GetCurrencyList, GetGlobalAccountPackagesDetails, GetSmsCountries, isClalAccount, checkYotpoConnection } from './redux/reducers/commonSlice';
import { getNotificationUpdates } from './redux/reducers/notificationUpdateSlice';
import { setUsername } from './redux/reducers/userSlice';
import { getTheme } from './style/theme';
import { darkTokens } from './style/tokens';
import { Chart } from 'chart.js';
import { ThemeProvider as MuiV5ThemeProvider, createTheme as createV5Theme } from '@mui/material/styles';
import { useClasses } from './style/classes/index';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import DirectSendReport from './screens/Reports/DirectSendReport/DirectSendReport';
import NotificationManagement from './screens/Notifications/Management/NotificationManagement';
import NotificationEdit from './screens/Notifications/Editor/NotificationEdit';
import NewslettersReport from './screens/Reports/NewslettersReport/NewslettersReport';
import { useMediaQuery } from '@material-ui/core';
import AppBaseline from './components/AppBaseline';
import { WhiteLabelObject } from './components/WhiteLabel/WhiteLabelMigrate';
import DashboardScreen from './screens/Dashboard/Dashboard';
import GraphicReport from './screens/Reports/NewslettersReport/GraphicReport';
import SmsReport from './screens/Reports/SmsReport/SmsReport';
import SmsCreator from './screens/Sms/Editor/SmsCreator';
import SmsSend from './screens/Sms/Editor/SmsSend';
import SiteTrackingEditor from './screens/SiteTracking/SiteTrackingEditor';
// import SmsReplies from './screens/Reports/Inbound/Sms/SmsReplies';
import Groups from './screens/Groups/Management/Groups';
import MmsReport from './screens/Reports/MmsReport/MmsReport.js';
import NewsLetterInfo from './screens/Newsletter/Wizard/NewsLetterInfo';
import ClientSearchResult from './screens/ClientSearch/ClientSearchResult';
import ProductsReport from './screens/Reports/ProductsReport/ProductsReport';
import SystemMessage from './screens/SystemFailure/SystemMessage';
import NotificationSend from './screens/Notifications/Editor/NotificationSend';
import WhatsappCreator from './screens/Whatsapp/Editor/WhatsappCreator';
import PageNotFound from './screens/404';
import AccountSettingsEditor from './screens/Settings/AccountSettings/AccountSettingsEditor';
import BillingSettingsPage from './screens/Settings/BillingSettings/BillingSettingsPage';
import { sitePrefix } from './config/index'
// import ResponsesReports from './screens/Reports/ResponsesReports/ResponsesReports';
import InboundMessages from './screens/Reports/Inbound/InboundMessages';
import NewsletterSendSettings from './screens/Newsletter/Wizard/NewsletterSendSettings';
import { whatsappRoutes } from './screens/Whatsapp/Constant';
import SaveCampain from './screens/Whatsapp/Campaign/SaveCampain';
import SendCampaign from './screens/Whatsapp/Campaign/SendCampaign';
import ManageWhatsAppTemplates from './screens/Whatsapp/management/ManageWhatsAppTemplates';
import WhatsappReports from './screens/Whatsapp/Reports/WhatsappReports';
import ManageWhatsAppCampaigns from './screens/Whatsapp/management/ManageWhatsAppCampaigns';
import WhatsappChat from './screens/Whatsapp/Chat/WhatsappChat';
import DownloadFiles from './screens/Reports/DownloadFiles/DownloadFiles.tsx';
import RecipientReport from './screens/Reports/RecipientReport/RecipientReport';
import Integrations from './screens/Integrations/Integrations';
import ApiSettings from './screens/Settings/ApiSettings/ApiSettings';
import AuthenticatorApp from './screens/Settings/AuthenticatorApp/AuthenticatorApp';
import SsoSettings from './screens/Settings/SsoSettings/SsoSettings';
import MySso from './screens/Settings/MySso/MySso';
import { getSsoMenuInfo } from './redux/reducers/MySsoSlice';
import DynamicGroups from './screens/Groups/Dynamic/DynamicGroups';
import EditDynamicGroup from './screens/Groups/Dynamic/EditDynamicGroup';
import CreateLandingPage from './screens/LandingPages/Wizard/CreateLandingPage';
import ExtraFields from './screens/Settings/ExtraFields/ExtraFields';
import { isSignupPage, isSubUserConfirmationPage } from './helpers/Utils/common';
import './helpers/global';
import SurveyDetails from './screens/LandingPages/Survey/SurveyDetails';
import WebformSummary from './screens/LandingPages/Wizard/WebformSummary';
import HtmlPreview from './screens/Preview/HtmlPreview';
import FileUploads from './screens/Groups/FileUploads/FileUploads';
import DataSources from './screens/DataSources/DataSources';
import DataSourceView from './screens/DataSources/DataSourceView';
import SmartSendScreen from './screens/SmartSend/SmartSendScreen';
import SmartSendPicker from './screens/SmartSend/SmartSendPicker';
import SendSearchScreen from './screens/SendSearch/SendSearchScreen';
import ClalCenterScreen from './screens/ClalCenter/ClalCenterScreen';
import AmpRegistration from './screens/Newsletter/AMP/AmpRegistration';
import AffiliateProgram from './screens/Affiliate/Management/AffiliateProgram';
import AccountUsers from './screens/AccountUsers/AccountUsers';
import TermsOfUsePage from './screens/TermsOfUse/TermsOfUsePage';
import SubUsers from './screens/UsersAndPermissions/SubUsers';
import WhatsappOnBoarding from './screens/Whatsapp/OnBoarding/WhatsappOnBoarding';
import SubUserConfirmationPage from './screens/UsersAndPermissions/SubUserConfirmationPage';
import { Loader } from './components/Loader/Loader';
import ClientSearch from './screens/ClientSearch/ClientSearch';
import CreateAutomationTemplate from './screens/Automations/CreateAutomation';
import SignUpNew from './screens/SignUp/SignUpNew';
import { UserRoles } from './Models/SubUser/SubUsers';
import { PulseemFeatures } from './model/PulseemFields/Fields';
import RemoveMyData from './screens/RemoveMyData/RemoveMyData';
import LinksClicksReport from './screens/Reports/LinksClicksReport/LinksClicksReport';
import PopupTriggers from './screens/Popups/DisplayRules/PopupTriggers';

import BeeEditorPopup from './screens/Editors/BeeEditorPopup';
import AIFloatingButton from './components/AI/AIFloatingButton';
import AIChatWidget from './components/AI/AIChatWidget';
import { advisorConfig, supportConfig } from './components/AI/chatConfig';
import { getAvailablePlans, getCurrentPlan } from './redux/reducers/TiersSlice';
import PopupSummary from './screens/Popups/PopupSummary';
import HelpDrawer from './components/HelpDrawer';
import LegacyPageFrame, { LegacyPageWild } from './screens/LegacyPage/LegacyPageFrame';
import { openHelpDrawer, closeHelpDrawer, toggleHelpDrawer } from './redux/reducers/helpDrawerSlice';
import ProTrialPlansLauncher from './components/ProTrial/ProTrialPlansLauncher';
import ProTrialReminders from './components/ProTrial/ProTrialReminders';
import { captureOpenPlansRequest } from './components/ProTrial/proTrialDeepLink';

// PR-3634 contracts v4 §6.5: keep the email's ?openPlans=pro request before any API call can send a
// signed-out visitor to login (Login.aspx always returns to the dashboard and drops the query).
captureOpenPlansRequest();

// Chart.js draws on <canvas>, so CSS can't reach its tick/legend/grid colors. Capture its
// own defaults once so light mode keeps exactly what it had.
const chartLightDefaults = { color: Chart.defaults.color, borderColor: Chart.defaults.borderColor, arcBorderColor: Chart.defaults.elements.arc.borderColor };

const renderRoutes = (classes, redirect, userRoles, accountFeatures) => {
  const transferUrl =
    (url = '', param = '') =>
      () => {
        const { campaignID, automationID, id, notificationID } = useParams();
        const addParam = {
          campaign: campaignID,
          automation: automationID,
          notification: notificationID,
          id: id,
        };

        window.location.href = `https://www.pulseem.co.il/${url}${addParam[param] || ''}`
        return <></>
      }
  return (
    <Routes>
      <Route
        exact
        path={`${sitePrefix}sign-up`}
        element={<SignUpNew classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}UserConfirmation`}
        element={<SubUserConfirmationPage classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}remove-my-data`}
        element={<RemoveMyData classes={classes} />}
      />
      <Route
        exact
        path={sitePrefix}
        element={<DashboardScreen classes={classes} />}
      />
      <Route
        path={`${sitePrefix}sms/create/`}
        element={<SmsCreator classes={classes} key="create" />}
      />
      <Route
        path={`${sitePrefix}sms/edit/:id`}
        element={<SmsCreator classes={classes} key="edit" />}
      />
      <Route

        path={`${sitePrefix}sms/send/:id`}
        element={<SmsSend classes={classes} />}
      />
      <Route
        path={`/PreviewCampaign/:campaignID`}
        component={transferUrl('/Pulseem/PreviewCampaign.aspx?CampaignID=', 'campaign')}
      />
      <Route
        path={`/Editor/CampaignEdit/:campaignID`}
        element={transferUrl('/Pulseem/Editor/CampaignEdit/', 'campaign')}
      />
      <Route
        path={`/DuplicateCampign/:campaignID`}
        element={transferUrl('/Pulseem/DuplicateCampign/', 'campaign')}
      />
      <Route
        path={`${sitePrefix}CampaignStatistics/:campaignID`}
        // component={transferUrl('/Pulseem/CampaignStatistics.aspx?CampaignID=', 'campaign')}
        element={<GraphicReport classes={classes} />}
      />
      <Route
        path={`${sitePrefix}Groups`}
        element={<Groups classes={classes} />}
      />
      {/* Newsletter */}
      <Route
        exact
        path={`${sitePrefix}Campaigns`}
        element={<NewsletterManagment classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}Campaigns/Create`}
        element={<NewsLetterInfo classes={classes} key="create" />}
      />
      <Route
        path={`${sitePrefix}Campaigns/Create/:id`}
        element={<NewsLetterInfo classes={classes} key="edit" />}
      />
      <Route
        exact
        path={`${sitePrefix}Campaigns/editor`}
        element={<CampaignEditorBee classes={classes} />}
      />
      <Route
        path={`${sitePrefix}Campaigns/editor/:id`}
        element={<CampaignEditorBee classes={classes} />}
      />
      {accountFeatures && accountFeatures?.indexOf(PulseemFeatures.Popup) > -1 && <Route
          path={`${sitePrefix}popupeditor/:id`}
          element={
            <BeeEditorPopup
              classes={classes}
              // clientId="ae1d76a4-107b-4f63-9849-360bfcad507c"
              // clientSecret="Y1dZCdbtjfeVVCsCWB4EQNlQNerm3iCtQKocywnY1d213XeUt08F"
              isPopupBuilder={true}
            />}
        />
      }
      <Route
        path={`${sitePrefix}editor/:type/:id`}
        element={<BeeEditor classes={classes} />}
      />
      {accountFeatures && accountFeatures?.indexOf(PulseemFeatures.Popup) > -1 && (
        <Route
          path={`${sitePrefix}Popups/DisplayRules/:id`}
          element={<PopupTriggers classes={classes} />}
        />
      )}
      <Route
        path={`${sitePrefix}Campaigns/SendSettings/:id`}
        element={<NewsletterSendSettings classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}Campaigns/Archive`}
        element={<ArchiveManagement classes={classes} />}
      />
      {/* SMS */}
      <Route
        path={`${sitePrefix}SMSCampaigns`}
        element={<SmsManagment classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}Campaigns/Archive`}
        element={<ArchiveManagement classes={classes} />}
      />
      <Route
        path={`/CampaignsByResults`}
        element={transferUrl('/Pulseem/CampaignsByResults.aspx')}
      />
      <Route
        path={`/CampaignsAbTestings`}
        element={transferUrl('/Pulseem/CampaignsAbTestings.aspx')}
      />
      <Route
        path={`${sitePrefix}AutoSendPlans`}
        element={<LegacyPageFrame path="AutoSendPlans.aspx" classes={classes} />}
      />
      {/* <Route
        path={`/CampaignTemplates`}
        element={transferUrl('/Pulseem/CampaignTemplates.aspx')}
      /> */}
      <Route
        path={`/CampaignEdit`}
        element={transferUrl('/Pulseem/CampaignEdit.aspx?NewsLetterType=Basic')}
      />
      <Route
        path={`/SMSSmartResponses`}
        element={<LegacyPageFrame path="SMSSmartResponses.aspx" classes={classes} />}
      />
      <Route
        path={`/SMSPreviewCampaign/:id`}
        component={transferUrl('/Pulseem/SMSPreviewCampaign.aspx?SMSCampaignID=', 'id')}
      />
      <Route
        path={`/Edit/SMSCampaignEdit/:id`}
        component={transferUrl('/Pulseem/SMSCampaignEdit.aspx?SMSCampaignID=', 'id')}
      />

      {/* MMS */}
      {accountFeatures && accountFeatures?.indexOf(PulseemFeatures.MMS) > -1 && <Route
        path={`${sitePrefix}MmsCampaigns`}
        element={<MmsManagment classes={classes} />}
      />}
      <Route
        path="/CreateMmsCampaign"
        element={<LegacyPageFrame path="MmsCampaignEdit.aspx" classes={classes} />}
      />
      <Route
        path='/MmsCampaignEdit/:id'
        component={transferUrl('/Pulseem/MmsCampaignEdit.aspx?MmsCampaignID=', 'id')}
      />
      <Route
        path='/MmsPreviewCampaign/:id'
        component={transferUrl('/Pulseem/MmsPreviewCampaign.aspx?MmsCampaignID=', 'id')}
      />
      <Route
        path='/SendMmsCampaign/:id'
        component={transferUrl('/Pulseem/SendMmsCampaign.aspx?MmsCampaignID=', 'id')}
      />
      {/* Landing Pages */}
      {/* Whatsapp */}

      {
        userRoles?.AllowWhatsAppToAgent &&
        <Route
          path={whatsappRoutes.CREATE_TEMPLATE}
          element={<WhatsappCreator classes={classes} key="wa-create" />}
        />
      }
      {
        userRoles?.AllowWhatsAppToAgent && 
        <Route
          path={whatsappRoutes.CREATE_CAMPAIGN_PAGE1}
          element={<SaveCampain classes={classes} />}
        />
      }
      {
        userRoles?.AllowWhatsAppToAgent &&
        <Route
          path={whatsappRoutes.CREATE_CAMPAIGN_PAGE2}
          element={<SendCampaign classes={classes} key="wa-send" />}
        />
      }
      {
        userRoles?.AllowWhatsAppToAgent &&
        <Route
          path={whatsappRoutes.TEMPLATE_MANAGEMENT}
          element={<ManageWhatsAppTemplates classes={classes} key="wa-template-management" />}
        />
      }
      {
        userRoles?.AllowWhatsAppToAgent &&
        <Route
          path={whatsappRoutes.REPORTS}
          element={<WhatsappReports classes={classes} key="wa-reports" />}
        />
      }
      {
        userRoles?.AllowWhatsAppToAgent &&
        <Route
          path={whatsappRoutes.CAMPAIGN_MANAGEMENT}
          element={<ManageWhatsAppCampaigns classes={classes} key="wa-CAMPAIGN_MANAGEMENT" />}
        />
      }

      {
        userRoles?.AllowWhatsAppToAgent &&
        <Route
          path={whatsappRoutes.EDIT_TEMPLATE}
          element={<WhatsappCreator classes={classes} key="wa-edit" />}
        />
      }
      {
        userRoles?.AllowWhatsAppToAgent &&
        <Route
          path={whatsappRoutes.EDIT_CAMPAIGN_PAGE1}
          element={<SaveCampain classes={classes} />}
        />
      }
      {
        userRoles?.AllowWhatsAppToAgent &&
        <Route
          path={whatsappRoutes.EDIT_CAMPAIGN_PAGE2}
          element={<SendCampaign classes={classes} key="wa-send-campaign-page2" />}
        />
      }

      {
        userRoles?.AllowWhatsAppToAgent &&
        <Route
          path={whatsappRoutes.CHAT}
        >
          {/* Same key on both routes: moving between /chat and /chat/:contactID must not remount the chat (it would reset the selected From Number). */}
          <Route index element={<WhatsappChat classes={classes} key="wa-chat" />} />
          <Route path=":contactID" element={<WhatsappChat classes={classes} key="wa-chat" />} />
        </Route>
      }
      <Route
        path='/NewWebForm/NewFormEdit/:id'
        component={transferUrl('/Pulseem/NewWebForm/NewFormEdit/', 'id')}
      />
      {!userRoles?.HideRecipients && <Route
        path={`${sitePrefix}ClientSearchResult/:referrer/:id`}
        element={<ClientSearchResult classes={classes} />}
      />}
      {!userRoles?.HideRecipients && <Route
        path={`${sitePrefix}ClientSearchResult`}
        element={<ClientSearchResult classes={classes} />}
      />}
      <Route
        path={`${sitePrefix}EditRegistrationPage`}
        element={<LandingPagesesManagment classes={classes} />}
      />
      {accountFeatures && accountFeatures?.indexOf(PulseemFeatures.Popup) > -1 && <Route
          path={`${sitePrefix}PopUpManagement`}
          element={<PopUpManagement classes={classes} />}
        />
      }
      <Route
        path={`${sitePrefix}LandingPages/Create`}
        element={<CreateLandingPage classes={classes} key="landing-create" />}
      />
      <Route
        path={`${sitePrefix}LandingPages/Create/:id`}
        element={<CreateLandingPage classes={classes} key="landing-edit" />}
      />
      <Route
        path={`${sitePrefix}Popups/Create`}
        element={<CreateLandingPage classes={classes} isPopup={true} key="popup-create" />}
      />
      <Route
        path={`${sitePrefix}Popups/Create/:id`}
        element={<CreateLandingPage classes={classes} isPopup={true} key="popup-edit" />}
      />
      <Route
        path={`${sitePrefix}LandingPages/SurveyDetails/:id`}
        element={<SurveyDetails classes={classes} />}
      />
      <Route
        path={`${sitePrefix}LandingPages/summary/:id`}
        element={<WebformSummary classes={classes} />}
      />
      <Route
        path={`${sitePrefix}landingPages/Popups/Summary/:id`}
         element={<PopupSummary classes={classes} />}
      />
      <Route
        path={`/Survey`}
        element={<LegacyPageFrame path="LandingPageWizard.aspx" classes={classes} />}
      />
      <Route
        path={`/FormTemplates`}
        element={<LegacyPageFrame path="FormTemplates.aspx" classes={classes} />}
      />
      {/* Reports */}
      <Route
        path={`${sitePrefix}Reports/NewsletterReports`}
        element={<NewslettersReport classes={classes} />}
      />
      <Route
        path={`/ClalReport`}
        element={<LegacyPageFrame path="ClalReport.aspx" classes={classes} />}
      />
      <Route
        path={`${sitePrefix}Reports/SMSMainReport`}
        element={<SmsReport classes={classes} />}
      />
      <Route
        path={`${sitePrefix}Reports/MmsMainReport`}
        element={<MmsReport classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}Reports/ProductsReport`}
        element={<ProductsReport classes={classes} />}
      />
      {/* <Route
        path={`/AbTestsReport`}
        component={transferUrl('/Pulseem/AbTestsReport.aspx')}
      /> */}
      <Route
        path={`${sitePrefix}AccountReport`}
        element={<LegacyPageFrame path="AccountReport.aspx" classes={classes} />}
      />
      <Route
        path={`${sitePrefix}EmailAutoReports`}
        element={<LegacyPageFrame path="EmailAutoReports.aspx" classes={classes} />}
      />
      <Route
        path={`${sitePrefix}RemovedStats`}
        element={<LegacyPageFrame path="RemovedStats.aspx" classes={classes} />}
      />
      <Route
        path={`${sitePrefix}DirectEmailReport`}
        element={<LegacyPageFrame path="DirectEmailReport.aspx" classes={classes} />}
      />
      {!userRoles?.HideRecipients && <Route
        exact
        path={`${sitePrefix}Reports/DirectSendReport`}
        element={<DirectSendReport classes={classes} isArchive={false} />}
      />}
      {!userRoles?.HideRecipients && <Route
        exact
        path={`${sitePrefix}Reports/DirectSendReport/Archive`}
        element={<DirectSendReport classes={classes} isArchive={true} />}
      />}
      <Route
        path={`${sitePrefix}EmailCampaignStatistics`}
        element={<LegacyPageFrame path="EmailCampaignStatistics.aspx" classes={classes} />}
      />
      <Route
        path={`${sitePrefix}reports/LinksClicksReport`}
        element={<LinksClicksReport classes={classes} />}
      />

      {/* Automations */}
      <Route
        path={`${sitePrefix}Automations`}
        element={<AutomationManagment classes={classes} />}
      />
      <Route
        path={`${sitePrefix}CreateAutomations`}
        element={<LegacyPageFrame path="CreateAutomations.aspx" classes={classes} />}
      />
      <Route
        path={`${sitePrefix}Automations/Create`}
        element={<CreateAutomationTemplate classes={classes} />}
      />

      <Route
        path="/EditAutomations/:id"
        component={transferUrl('/Pulseem/CreateAutomations.aspx?AutomationID=', 'id')}
      />
      <Route
        path="/PreviewAutomations/:id"
        component={transferUrl('/Pulseem/CreateAutomations.aspx?Mode=show&AutomationID=', 'id')}
      />
      <Route
        path="/AutomationReport/:id"
        component={transferUrl('/Pulseem/automationreport.aspx?AutomationID=', 'id')}
      />
      {/* Notifications */}
      <Route
        exact
        path={`${sitePrefix}Notifications`}
        element={<NotificationManagement classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}Notification/create`}
        element={<NotificationEdit classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}Notification/edit/:id`}
        element={<NotificationEdit classes={classes} key="edit" />}
      />
      <Route
        exact
        path={`${sitePrefix}Notification/send/:id`}
        element={<NotificationSend classes={classes} key="send" />}
      />
      {/* Settings */}
      {userRoles === UserRoles.Admin && <Route
        exact
        path={`${sitePrefix}AccountSettings`}
        element={<AccountSettingsEditor classes={classes} />}
      />}
      {userRoles === UserRoles.Admin && <Route
        exact
        path={`${sitePrefix}BillingSettings`}
        element={<BillingSettingsPage classes={classes} />}
      />}
      <Route
        path={`${sitePrefix}AccountBilling`}
        element={<LegacyPageFrame path="AccountBilling.aspx" classes={classes} />}
      />
      {userRoles === UserRoles.Admin && <Route
        exact
        path={`${sitePrefix}AccountUsers`}
        element={<AccountUsers classes={classes} />}
      />}
      {userRoles === UserRoles.Admin && <Route
        path={`${sitePrefix}AccountUsersReport`}
        element={<LegacyPageFrame path="AccountUsersReport.aspx" classes={classes} />}
      />}
      <Route
        path={`${sitePrefix}ExtraFieldsDefinition`}
        element={<LegacyPageFrame path="ExtraFieldsDefinition.aspx" classes={classes} />}
      />
      {userRoles?.AllowSend && <Route
        path={`${sitePrefix}ApiSettings`}
        element={<ApiSettings classes={classes} />}
      />}
      <Route
        path={`${sitePrefix}SubUsers`}
        element={<SubUsers classes={classes} />}
      />
      {/* Authenticator app (2FA) - every user (main login and SubUsers) sets up their own */}
      <Route
        path={`${sitePrefix}AuthenticatorApp`}
        element={<AuthenticatorApp classes={classes} />}
      />
      {/* SSO login - every user connects their own company login (after the admin set it up in SSO (SAML)) */}
      <Route
        path={`${sitePrefix}MySso`}
        element={<MySso classes={classes} />}
      />
      {/* SSO (SAML) self-setup - account Admin only */}
      {userRoles === UserRoles.Admin && <Route
        path={`${sitePrefix}SsoSettings`}
        element={<SsoSettings classes={classes} />}
      />}
      {/* Support */}
      <Route
        path={`/Support`}
        element={() => {
          window.open("https://www.pulseem.co.il/Pages/Home.aspx?action=support", "_blank")
          return null
        }}
      />
      {userRoles?.AllowSend && <Route
        exact
        path={`${sitePrefix}SiteTracking`}
        element={<SiteTrackingEditor classes={classes} />}
      />}
      <Route
        exact
        path={`${sitePrefix}SystemMessage`}
        element={<SystemMessage classes={classes} />}
      />
      {userRoles?.AllowSend && <Route exact
        path={`${sitePrefix}Integrations`}
        element={<Integrations classes={classes} />}
      />}
      {
        userRoles?.AllowWhatsAppToAgent && 
        <Route exact
          path={`${sitePrefix}whatsapp-onboarding`}
          element={<WhatsappOnBoarding classes={classes} />}
        />
      }
      {!userRoles?.HideRecipients && <Route
        exact
        path={`${sitePrefix}reports/Inbound`}
        element={<InboundMessages classes={classes} key="all" />}
      />}
      {!userRoles?.HideRecipients && <Route
        exact
        path={`${sitePrefix}reports/Inbound/:type`}
        element={<InboundMessages classes={classes} />}
      />}
      {!userRoles?.HideRecipients && <Route
        exact
        path={`${sitePrefix}reports/Inbound/:type/:id`}
        element={<InboundMessages classes={classes} key="byTypeId" />}
      />}
      <Route
        exact
        path={`${sitePrefix}Groups/FileUploads`}
        element={<FileUploads classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}Groups/Download`}
        element={<DownloadFiles classes={classes} />}
      />
      <Route
        path="/Pulseem/:aspxPage"
        element={<LegacyPageWild classes={classes} />}
      />
      {accountFeatures && accountFeatures?.indexOf(PulseemFeatures.DATA_SOURCES) > -1 && <Route
        exact
        path={`${sitePrefix}DataSources`}
        element={<DataSources classes={classes} />}
      />}
      {accountFeatures && accountFeatures?.indexOf(PulseemFeatures.DATA_SOURCES) > -1 && <Route
        exact
        path={`${sitePrefix}DataSources/View/:id`}
        element={<DataSourceView classes={classes} />}
      />}
      {userRoles?.AllowSend && accountFeatures && accountFeatures?.indexOf(PulseemFeatures.DATA_SOURCES) > -1 && <Route
        exact
        path={`${sitePrefix}Campaigns/SmartSend/:id`}
        element={<SmartSendScreen classes={classes} />}
      />}
      {userRoles?.AllowSend && accountFeatures && accountFeatures?.indexOf(PulseemFeatures.DATA_SOURCES) > -1 && <Route
        exact
        path={`${sitePrefix}SmartSend`}
        element={<SmartSendPicker classes={classes} />}
      />}
      {/* Deliberately NOT gated on AllowSend — this is a read-only report and supervisors/support
          need it without send permission. HideRecipients IS gated: SendSearchController answers the
          Search action with 405 for that permission because the grid returns recipient PII, so the
          route would only ever open a page that cannot search. Must stay identical to the sidebar
          gate in routes.tsx (P3.2). */}
      {accountFeatures && accountFeatures?.indexOf(PulseemFeatures.DATA_SOURCES) > -1 && !userRoles?.HideRecipients && <Route
        exact
        path={`${sitePrefix}SendSearch`}
        element={<SendSearchScreen classes={classes} />}
      />}
      {/* CLAL CENTER (מרכז כלל). The ROUTE carries its own gate, not just the sidebar entry:
          without it, typing /ClalCenter renders the screen for every logged-in user in every
          account. Must stay identical to the sidebar gate in routes.tsx. */}
      {accountFeatures && accountFeatures?.indexOf(PulseemFeatures.CLAL_CENTER) > -1 && <Route
        exact
        path={`${sitePrefix}ClalCenter`}
        element={<ClalCenterScreen classes={classes} />}
      />}
      <Route
        path="*" element={<PageNotFound classes={classes} />}
      />
      {!userRoles?.HideRecipients && <Route
        exact
        path={`${sitePrefix}reports/recipient`}
        element={<RecipientReport classes={classes} />}
      />}
      <Route
        exact
        path={`${sitePrefix}Groups/Dynamic`}
        element={<DynamicGroups classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}groups/dynamic/edit/:id`}
        element={<EditDynamicGroup classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}AccountSettings/ExtraFields`}
        element={<ExtraFields classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}Campaigns/AmpRegistration`}
        element={<AmpRegistration classes={classes} />}
      />
      <Route
        exact
        path={`${sitePrefix}Previewer/:type/:id`}
        element={<HtmlPreview classes={classes} />}
      />
      {userRoles === UserRoles.Admin && <Route
        exact
        path={`${sitePrefix}AffiliateManagement`}
        element={<AffiliateProgram classes={classes} />}
      />}
      <Route
        exact
        path={`${sitePrefix}TermsOfUse`}
        element={<TermsOfUsePage classes={classes} />}
      />
      {!userRoles?.HideRecipients && <Route
        exact
        path={`${sitePrefix}ClientSearch`}
        element={<ClientSearch classes={classes} />}
      />}
    </Routes>
  )
}

const App = ({ screenSize }) => {
  let location = useLocation();
  const dispatch = useDispatch();

  const { language, isRTL, windowSize, isClal, isDebtAccount, isAdmin, isLoader, userRoles, isOnlyWhatsAppChat, subUserName, subUserObject, email, companyName, isDrawerOpen, isDarkMode } = useSelector(state => state.core)
  const { accountSettings, currencyList, accountFeatures } = useSelector(state => state.common)
  const IsPoland = language === 'pl';
  const { isOpen } = useSelector((state) => state.helpDrawer);
  const classes = useClasses(windowSize, isRTL, IsPoland)();
  setCookie('accountSettings', '');
  const isSignup = isSignupPage(location.pathname);
  const isConfirmationPage = isSubUserConfirmationPage(location.pathname)

  useEffect(() => {
    const direction = getDirection(i18n.language);
    document.documentElement.setAttribute('dir', direction);
  }, []);

  // Identify the logged-in user to the pulseemsupport.com chat widget (public/index.html) so
  // support agents see who they're talking to without asking. window.pulseem.currentUser is
  // the widget's own read of a host-page global (confirmed against its live source) - it is
  // not a DOM attribute or URL param, so PII here never becomes visible markup.
  const subUserEmail = subUserObject?.Data?.Emails?.[0]?.AuthValue;
  const subUserCellphone = subUserObject?.Data?.Cellphones?.[0]?.AuthValue;
  const defaultCellNumber = accountSettings?.DefaultCellNumber;
  useEffect(() => {
    const user = buildPulseemUser({ subUserName, subUserEmail, subUserCellphone, email, companyName, defaultCellNumber });
    window.pulseem = window.pulseem || {};
    window.pulseem.currentUser = user ? { ...user, name: user.username } : undefined;
  }, [subUserName, subUserEmail, subUserCellphone, email, companyName, defaultCellNumber]);

  React.useEffect(() => {
    !isSignup && !isConfirmationPage && dispatch(getNotificationUpdates());
    document.documentElement.setAttribute('data-url', window.location.pathname);
  }, [location]);

  useEffect(() => {
    screenSize && dispatch(setWindowSize(screenSize));
  }, [screenSize]);

  useEffect(() => {
    if (!isSignup && !isConfirmationPage && currencyList?.length > 0) {
      dispatch(GetGlobalAccountPackagesDetails());
    }
  }, [currencyList]);

  useEffect(() => {
    const initFeatures = async () => {
      if (!accountSettings) {
        await dispatch(getCommonFeatures());
      }
      dispatch(getSsoMenuInfo()); // SSO menu: hide "SSO (SAML)" in a sub-account that uses the main account's login, show "SSO login" only when available
      await dispatch(checkYotpoConnection());
      if (isClal === null) {
        const response = await dispatch(isClalAccount());
        dispatch(setIsClal(response.payload));
      }
    }

    const updateToken = () => {
      const culture = getCookie('Culture');
      const token = getCookie('jtoken');
      const rpp = getCookie('rpp') || 6;
      if (!token) return;
      const jwt = jwt_decode(token);
      const {
        email = '',
        unique_name = '', // SubUser permissions
        nameid: companyName,
        certthumbprint: billingTypeId,
        role: isAdmin,
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/homephone':
        isDebtAccount = '',
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/locality':
        locality = 'he-IL',
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/stateorprovince':
        imageURL = '',
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/uri':
        isWhiteLabel = '',
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/authorizationdecision':
        cameFromSubAccount = '',
        // 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': isAdmin = '',
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name':
        basename = '',
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata':
        isAllowSwitchAccount = '',
        OperationType = ''
      } = jwt;
      dispatch(
        setCoreData({
          email,
          basename,
          isDebtAccount,
          imageURL,
          isWhiteLabel,
          companyName,
          cameFromSubAccount,
          isAdmin,
          isAllowSwitchAccount,
          billingTypeId,
          unique_name,
          isOnlyWhatsAppChat: OperationType === "WhatsappChat",
        })
      );
      let lang = culture || locality; //||'he'
      setCookie('Culture', lang.toLowerCase())
      lang = lang.split('-')[0]
      i18n.changeLanguage(lang.toLowerCase())
      dispatch(setRowsPerPage(rpp || 6))
      dispatch(setLanguage(lang.toLowerCase()))
      dispatch(setUsername(companyName))
      // userName.current = companyName;
    }

    const cookieFunctionObj = {
      jtoken: updateToken,
    };

    // window.addEventListener('resize',setWindowWidth)
    cookieListener(({ name }) => {
      const cookieFunction = cookieFunctionObj[name] || null
      if (!!cookieFunction)
        cookieFunction()
    })
    !isSignup && !isConfirmationPage && updateToken()
    !isSignup && !isConfirmationPage && initFeatures()
    !isSignup && !isConfirmationPage && dispatch(GetCurrencyList());
    !isSignup && !isConfirmationPage && dispatch(GetSmsCountries());
    !isSignup && !isConfirmationPage && dispatch(GetAfterLoginInitialData());
    !isSignup && !isConfirmationPage && dispatch(getCurrentPlan());
    !isSignup && !isConfirmationPage && dispatch(getAvailablePlans());
  }, [dispatch])

  const getDirection = (lang) => {
    const rtlLanguages = ['ar', 'he', 'fa', 'ur'];
    return rtlLanguages.includes(lang) ? 'rtl' : 'ltr';
  };

  const redirect = useNavigate()

  useEffect(() => {
    const pageRoutes = {
      dashboard:        `${sitePrefix}`,
      campaigns:        `${sitePrefix}Campaigns`,
      sms:              `${sitePrefix}SMSCampaigns`,
      mms:              `${sitePrefix}MmsCampaigns`,
      automations:      `${sitePrefix}Automations`,
      notifications:    `${sitePrefix}Notifications`,
      groups:           `${sitePrefix}Groups`,
      landingpages:     `${sitePrefix}EditRegistrationPage`,
      newsletters:      `${sitePrefix}Reports/NewsletterReports`,
      smsreport:        `${sitePrefix}Reports/SMSMainReport`,
      mmsreport:        `${sitePrefix}Reports/MmsMainReport`,
      billing:          `${sitePrefix}BillingSettings`,
      accountsettings:  `${sitePrefix}AccountSettings`,
      integrations:     `${sitePrefix}Integrations`,
      subusers:         `${sitePrefix}SubUsers`,
      whatsapp:         whatsappRoutes.CAMPAIGN_MANAGEMENT,
    };
    const handleIframeMessage = (e) => {
      if (e.data?.type === 'react-navigate' && e.data?.page) {
        const page = e.data.page.toLowerCase();
        if (page === 'back') return redirect(-1);
        const route = pageRoutes[page] ?? pageRoutes['dashboard'];
        redirect(route);
      }
    };
    window.addEventListener('message', handleIframeMessage);
    return () => window.removeEventListener('message', handleIframeMessage);
  }, [redirect]);
  document.body.classList.add(classes.sidebar);

  if (isRTL) document.body.classList.add('rtl');
  else document.body.classList.remove('rtl');

  // Exposes dark/light mode the same way `rtl` above exposes direction — tokens.css's
  // custom properties are scoped to `[data-theme="dark"]` on <html>. The anti-flash
  // inline script in public/index.html sets this attribute pre-mount from localStorage;
  // this keeps it in sync once redux state is available/changes.
  document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');

  // White-label accounts have no theme toggle (TopMenu), but pls_theme is per browser — e.g. saved
  // by a Pulseem admin before opening a white-label account — so switch them to light without
  // overwriting the saved preference. Same isWhiteLabel idiom as TopMenu.
  const isWhiteLabelAccount = accountSettings?.Account?.ReferrerID > 0 && WhiteLabelObject[accountSettings?.Account?.ReferrerID] !== undefined;
  useEffect(() => {
    if (isWhiteLabelAccount && isDarkMode) dispatch(setDarkModeTransient(false));
  }, [isWhiteLabelAccount, isDarkMode, dispatch]);

  // Printing must match light mode exactly: browsers drop background colors when printing but
  // keep text colors, so a dark-mode printout would be near-white text on white paper. Switch to
  // light for the print (not persisted) and back afterwards. Outside React's event system, React 17
  // re-renders synchronously, so the print snapshot is taken after the switch.
  const isDarkModeRef = useRef(isDarkMode);
  isDarkModeRef.current = isDarkMode;
  useEffect(() => {
    let restoreDark = false;
    const onBeforePrint = () => {
      if (!isDarkModeRef.current) return;
      restoreDark = true;
      // Freezes CSS transitions (tokens.css) so animated colors, e.g. MUI's input labels,
      // land on their light values before the print snapshot instead of mid-transition.
      document.documentElement.setAttribute('data-printing', '');
      dispatch(setDarkModeTransient(false));
    };
    const onAfterPrint = () => {
      if (!restoreDark) return;
      restoreDark = false;
      dispatch(setDarkModeTransient(true));
      document.documentElement.removeAttribute('data-printing');
    };
    window.addEventListener('beforeprint', onBeforePrint);
    window.addEventListener('afterprint', onAfterPrint);
    return () => {
      window.removeEventListener('beforeprint', onBeforePrint);
      window.removeEventListener('afterprint', onAfterPrint);
    };
  }, [dispatch]);
  const chartColors = isDarkMode ? { color: darkTokens.textSecondary, borderColor: darkTokens.divider, arcBorderColor: darkTokens.surface } : chartLightDefaults;
  if (Chart.defaults.color !== chartColors.color || Chart.defaults.borderColor !== chartColors.borderColor || Chart.defaults.elements.arc.borderColor !== chartColors.arcBorderColor) {
    Chart.defaults.color = chartColors.color;
    Chart.defaults.borderColor = chartColors.borderColor;
    Chart.defaults.elements.arc.borderColor = chartColors.arcBorderColor;
    Object.values(Chart.instances || {}).forEach((c) => c && c.update && c.update('none'));
  }

  // Exposes the sidebar's collapsed/expanded state to plain global CSS, the same way
  // `rtl` above exposes direction — needed so the externally-hosted support widget
  // (pulseemsupport.com/widget.js, injected via index.html, entirely outside this
  // React tree) can be repositioned to clear the sidebar via CSS alone. Note:
  // redux's `isDrawerOpen` is named for the toggle action, not the visual result — it
  // is actually true when the sidebar IS collapsed (narrow rail), false when expanded.
  if (isDrawerOpen) document.body.classList.add('sidebar-collapsed');
  else document.body.classList.remove('sidebar-collapsed');

  // Add polish-account class for Polish accounts
  if (IsPoland) document.body.classList.add('polish-account');
  else document.body.classList.remove('polish-account');

  // Hide accessibility elements when in WhatsApp chat only mode
  useEffect(() => {
    const styleId = 'whatsapp-only-hide-accessibility';

    if (isOnlyWhatsAppChat) {
      document.body.setAttribute('data-only-whatsapp-chat', 'true');

      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
        #INDmenu-btn,
        [data-accessibility-container] { 
          display: none !important; 
        }
      `;
        document.head.appendChild(style);
      }
    } else {
      document.body.removeAttribute('data-only-whatsapp-chat');
      const style = document.getElementById(styleId);
      if (style) style.remove();
    }
  }, [isOnlyWhatsAppChat]);

  const renderRoutesByCondition = (classes, redirect) => {
    const ignoreCookie = getCookie('ignoreTerm')

    if (isOnlyWhatsAppChat && userRoles?.AllowWhatsAppToAgent) {
      return <Routes>
        <Route
          path={whatsappRoutes.CHAT}
        >
          {/* Same key on both routes: moving between /chat and /chat/:contactID must not remount the chat (it would reset the selected From Number). */}
          <Route index element={<WhatsappChat classes={classes} key="wa-chat" />} />
          <Route path=":contactID" element={<WhatsappChat classes={classes} key="wa-chat" />} />
        </Route>
        <Route path="*" element={<WhatsappChat classes={classes} key="wa-chat-fallback" />} />
      </Routes>
    } else if (accountSettings && accountSettings?.SubAccountSettings?.IsTokenAccount) {
      return <Routes>
        <Route
          path={`${sitePrefix}Groups`}
          element={<Groups classes={classes} />}
        />
        <Route
          path={`${sitePrefix}ClientSearchResult`}
          element={<ClientSearchResult classes={classes} />}
        />
        <Route
          path={`${sitePrefix}EditRegistrationPage`}
          element={<LandingPagesesManagment classes={classes} />}
        />
        <Route
          path={`${sitePrefix}LandingPages/Create`}
          element={<CreateLandingPage classes={classes} />}
        />
        <Route
          path={`${sitePrefix}LandingPages/Create/:id`}
          element={<CreateLandingPage classes={classes} />}
        />
        <Route
          path={`${sitePrefix}Popups/Create`}
          element={<CreateLandingPage classes={classes} isPopup={true} />}
        />
        <Route
          path={`${sitePrefix}Popups/Create/:id`}
          element={<CreateLandingPage classes={classes} isPopup={true} />}
        />
        <Route
          path={`${sitePrefix}LandingPages/SurveyDetails/:id`}
          element={<SurveyDetails classes={classes} />}
        />
        <Route
          path={`${sitePrefix}LandingPages/summary/:id`}
          element={<WebformSummary classes={classes} />}
        />
        <Route
          path={`${sitePrefix}popupeditor/:id`}
          element={<BeeEditorPopup classes={classes} 
          // clientId="ae1d76a4-107b-4f63-9849-360bfcad507c" 
          // clientSecret="Y1dZCdbtjfeVVCsCWB4EQNlQNerm3iCtQKocywnY1d213XeUt08F"
          isPopupBuilder={true} />}
        />
        <Route
          path={`${sitePrefix}editor/:type/:id`}
          element={<BeeEditor classes={classes} />}
        />
        <Route
          path={`${sitePrefix}AccountSettings/ExtraFields`}
          element={<ExtraFields classes={classes} />}
        />
        <Route
          path={`${sitePrefix}Previewer/:type/:id`}
          element={<HtmlPreview classes={classes} />}
        />
        <Route
          path={`${sitePrefix}Groups/Download`}
          element={<DownloadFiles classes={classes} />}
        />
        <Route
          path={`${sitePrefix}Groups/FileUploads`}
          element={<FileUploads classes={classes} />}
        />
        <Route
          path={`${sitePrefix}`}
          element={<LandingPagesesManagment classes={classes} />}
        />
        <Route
          path="*" element={<PageNotFound classes={classes} />}
        />
      </Routes>
    }
    if (!isAdmin && accountSettings && !accountSettings?.SubAccountSettings?.IsTermsApproved && accountSettings?.SubAccountSettings?.IgnoranceCount === 3 && ignoreCookie !== 'true') {
      return <Routes>
        <Route
          exact
          path="*"
          element={<TermsOfUsePage classes={classes} />}
        />
      </Routes>
    }
    if (!isAdmin && isDebtAccount === true) {
      return <Routes>
        <Route
          exact
          path="*"
          element={<BillingSettingsPage classes={classes} />}
        />
      </Routes>
    }
    else {
      return renderRoutes(classes, redirect, userRoles, accountFeatures);
    }

  }

  return (accountSettings || isSignup || isConfirmationPage) && (
    <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment} locale={language}>
      {/* No separate MuiThemeProvider here anymore — AppContainer's outer one already
          covers this whole subtree via React context (context propagates to all
          descendants regardless of nesting depth), so AppBaseline and everything else
          below already resolves to it. A second provider with its own separately-
          memoized `theme` object gave MUI's makeStyles/withStyles sheet cache — which
          keys on theme object identity — two different references for the same
          component tree, so components mounted under each independently registered
          their own JSS sheet. Once two sheets both claimed the same "global" Mui class
          name (e.g. MuiFormControl-root), JSS fell back to a counter-suffixed name for
          the second one, breaking any plain-CSS selector written assuming that class
          stays unsuffixed (e.g. ganaralStyle.js's dropdown-arrow color/position rule
          on the Newsletter Create screen's Select fields) — reproduced even on a
          single fresh page load, confirmed absent on an unmodified checkout with only
          the single (App's own) provider. */}
      <AppBaseline />
      <div dir={isRTL ? 'rtl' : 'ltr'} className={classes.appBody}>
        {renderRoutesByCondition(classes, redirect)}
        {!isSignup && !isConfirmationPage && !isOnlyWhatsAppChat && <ProTrialPlansLauncher classes={classes} />}
        {!isSignup && !isConfirmationPage && !isOnlyWhatsAppChat && <ProTrialReminders classes={classes} />}
        { !isOnlyWhatsAppChat && <AIChatWidget config={advisorConfig} />}
        { !isOnlyWhatsAppChat && <AIFloatingButton config={advisorConfig} /> }
        { !isOnlyWhatsAppChat && <AIChatWidget config={supportConfig} /> }
        { !isOnlyWhatsAppChat && <AIFloatingButton config={supportConfig} /> }
        { !isOnlyWhatsAppChat && <HelpDrawer open={isOpen} onClose={() => dispatch(closeHelpDrawer())} /> }
      </div>
      <Loader isOpen={isLoader} showBackdrop={true} />
    </MuiPickersUtilsProvider >

  )
}

function useWidth() {
  const { language } = useSelector((state) => state.core);
  // Only breakpoints are read below — mode intentionally omitted (breakpoints don't
  // vary by mode) — memoized since this rebuilds a full theme otherwise unused.
  const theme = useMemo(() => getTheme(language), [language]);
  // theme.breakpoints.keys is hardcoded by MUI to ['xs','sm','md','lg','xl'] and ignores
  // custom keys added to theme.js's breakpoint values, so 'sl' is inserted here manually.
  const keys = ['xl', 'lg', 'sl', 'md', 'sm', 'xs'];
  return (
    keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || 'xs'
  );
}

const AppContainer = () => {
  // Was rebuilt on every AppContainer re-render (state.core is a single slice object,
  // so any field change in it — not just language/isDarkMode below — gives useSelector
  // a new reference and re-renders this component). Handing StylesProvider a new `jss`
  // identity repeatedly, without the old one ever unmounting, piles up orphaned JSS
  // sheets; once two sheets both claim a "global" Mui class name (e.g. MuiFormControl-root),
  // JSS falls back to a counter-suffixed name (MuiFormControl-root-12797) for the newer one,
  // breaking any plain-CSS selector (ganaralStyle.js's `.jssNNNN.MuiFormControl-root svg`)
  // written assuming that class stays unsuffixed. Memoizing keeps one stable jss instance
  // for the app's lifetime, same as the theme below.
  const jss = useMemo(() => create({ plugins: [...jssPreset().plugins, rtl()] }), []);
  const width = useWidth();
  // App's own <MuiThemeProvider> (further down the tree) only wraps App's children,
  // not App itself — so hooks that run during App's render (e.g. useClasses(), which
  // depends on theme.custom for the dark-mode toolbar tokens added in PR-3800) would
  // otherwise see MUI's bare fallback default theme instead of this app's real one.
  // Providing the real theme here, one level up, fixes that without touching App's
  // own (harmless, now-redundant) inner provider.
  const { language, isDarkMode } = useSelector((state) => state.core);
  // Memoized for the same reason as App's own theme (see its comment) — this
  // provider sits above BrowserRouter, so every route change would otherwise
  // rebuild the theme and hand descendants (useClasses(), TopMenu/NotificationBell/
  // Loader's useTheme()) a new object identity for no reason.
  const theme = useMemo(
    () => getTheme(language, isDarkMode ? 'dark' : 'light'),
    [language, isDarkMode]
  );
  // The v5 (@mui/material) Select/Autocomplete/Switch/Slider used by some screens read their
  // own theme, not the v4 one above. Light mode gets createTheme() with no options, which is
  // exactly v5's built-in default those components already fall back to; the provider stays
  // mounted in both modes so toggling doesn't remount the app.
  const v5Theme = useMemo(
    () => (isDarkMode
      ? createV5Theme({
        palette: {
          mode: 'dark',
          primary: { main: darkTokens.accentPrimary },
          background: { default: darkTokens.background, paper: darkTokens.surface },
          text: { primary: darkTokens.textPrimary, secondary: darkTokens.textSecondary, disabled: darkTokens.textDisabled },
          divider: darkTokens.divider,
        },
      })
      : createV5Theme()),
    [isDarkMode]
  );

  return (
    <StylesProvider jss={jss}>
      <MuiThemeProvider theme={theme}>
        <MuiV5ThemeProvider theme={v5Theme}>
          <BrowserRouter basename='/'>
            <App screenSize={width} />
          </BrowserRouter>
        </MuiV5ThemeProvider>
      </MuiThemeProvider>
    </StylesProvider>
  );
};

export default AppContainer;
